import React from 'react'

import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import DirectionsIcon from '@material-ui/icons/Navigation'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER } from 'api/actions'
import PanelExpanded from 'api/PanelExpanded'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import SearchPanelDirectionsDistance from 'drawer/tabs/search/panels/SearchPanelDirectionsDistance'
import SearchPanelDirectionsEnd from 'drawer/tabs/search/panels/SearchPanelDirectionsEnd'
import SearchPanelDirectionsOptions from 'drawer/tabs/search/panels/SearchPanelDirectionsOptions'
import SearchPanelDirectionsStart from 'drawer/tabs/search/panels/SearchPanelDirectionsStart'
import SearchPanelExternalLinks from 'drawer/tabs/search/panels/SearchPanelExternalLinks'

const styles = theme => ({
  root: {},
  rootDetails: {
    padding: 10,
    maxHeight: 400,
    overflowY: 'auto'
  },
  logoWrapper: {
    width: '100%'
  },
  logo: {
    maxWidth: 300,
    maxHeight: 70,
    margin: '0 auto',
    display: 'table'
  },
  loading: {
    paddingTop: 10
  },
  progress: {
  }
})

class SearchPanelDirections extends React.Component {
  constructor (props) {
    super(props)
    const { title } = props

    this.pure = {}
    this.pure.title = title
    this.pure.headerIcon = <DirectionsIcon />
  }

  render () {
    const { classes, enabled, expanded, toggleExpansionPanel, pathFinder } = this.props

    if (!enabled) {
      return null
    }

    let pathLoadedMarkup = null

    if (isNil(pathFinder)) {
      pathLoadedMarkup = <div className={classes.loading}>
        <Grid container spacing={0}>
          <Grid item xs={1}><CircularProgress className={classes.progress} size={20} /></Grid>
          <Grid item xs={11}>Generating shade network...</Grid>
        </Grid>
      </div>
    } else {
      pathLoadedMarkup = <div>
        <SearchPanelDirectionsStart />
        <SearchPanelDirectionsEnd />
        <SearchPanelDirectionsDistance />
        <SearchPanelExternalLinks />
      </div>
    }

    let markup = null
    if (expanded) {
      markup = (
        <div className={classes.rootDetails}>
          <SearchPanelDirectionsOptions />
          {pathLoadedMarkup}
        </div>
      )
      PanelExpanded(LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED)
    }

    return (
      <div className={classes.root}>
        <AccordionWrapper
          expanded={expanded}
          onChange={toggleExpansionPanel}
          headerIcon={this.pure.headerIcon}
          title={this.pure.title}
          bExcludeExpandIcon={false}
        >
          {markup}
        </AccordionWrapper>
      </div>
    )
  }
}

SearchPanelDirections.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpansionPanel: PropTypes.func.isRequired,
  pathFinder: PropTypes.object
}

function mapStateToProps (state, ownProps) {
  const enabled = get(state, 'config.layout.drawer.tabs.search.panels.directions.enabled', true) // See templates.json
  const title = get(state, 'config.layout.drawer.tabs.search.panels.directions.title', 'Directions') // See templates.json
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, true)
  const pathFinder = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_PATH_FINDER, null)
  return {
    enabled,
    title,
    expanded,
    pathFinder
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanelDirections)
  )
)
